export default "__VITE_ASSET__HsMcpiI9__"